const forms = [
  {
    name: "Period Information",
    options: [
      {
        name: "Select Branch",
        type: "select",
        form: {
          name: "branch_id",
          placeholder: "Select Branch",
          value: "",
          required: true,
          showSearch: true,
          options: [],
          api:"get-all-branches"
        },
      },
      {
        name: "Period Start",
        type: "date",
        form: {
          type: "date",
          name: "period_start",
          placeholder: "Start Date",
          value: "",
          required: true,
        },
      },
      {
        name: "Period End",
        type: "date",
        form: {
          type: "date",
          name: "period_end",
          placeholder: "End Date",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Financial Details",
    options: [
      {
        name: "Opening Balance",
        type: "input",
        form: {
          type: "number",
          name: "opening_balance",
          placeholder: "Opening Balance",
          value: "0",
          required: false,
          disabled: true,
        },
      },
      {
        name: "Total Debit",
        type: "input",
        form: {
          type: "number",
          name: "total_debit",
          placeholder: "Total Debit",
          value: "0",
          required: false,
        },
      },
      {
        name: "Total Credit",
        type: "input",
        form: {
          type: "number",
          name: "total_credit",
          placeholder: "Total Credit",
          value: "0",
          required: false,
        },
      },
      {
        name: "Closing Balance",
        type: "input",
        form: {
          type: "number",
          name: "closing_balance",
          placeholder: "Closing Balance",
          value: "0",
          required: false,
          disabled: true,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Lock Period",
        type: "checkbox",
        form: {
          name: "is_locked",
          value: false,
          label: "Lock this period to prevent modifications",
        },
      },
    ],
  },
];

export default forms;